/**
 * Converts a number to exponential notation with a specific format.
 * For large numbers, formats them as "XE+Y" where X is the first digit
 * and Y is the power of 10 (rounded to multiples of 3).
 *
 * @param value - The number to convert to exponential notation
 * @returns A string representation in exponential notation (e.g., "1E+6" for 1000000)
 *
 * @example
 * toExponential(1000000) // Returns "1E+6"
 * toExponential(123456789) // Returns "1E+8"
 * toExponential(5432) // Returns "5E+3"
 */
export const toExponential = (value: number) => {
  const valueString = value.toFixed(0);
  const isExpString = /^\d\.\d+/.test(valueString);
  if (isExpString) {
    return valueString.replace(/^(\d)(\.)(\d{0,3})\d+?e\+(\d+)$/, '$1.$3E+$4');
  }
  const pow = Math.floor((valueString.length - 1) / 3) * 3;
  return valueString.replace(/^(\d)(\d{3})(.+)$/, `$1E+${pow}`);
};
